import React from 'react';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { Box, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ComponentInfo, DisplayGroupRender } from '@components';
import { rem } from '@helpers';
import { LEFT_PANEL_WIDTH } from '@constants';
import { useValuesByScreenSize } from '@hooks';

export const LeftPanel: React.FC<DisplayGroupProps> = (props: DisplayGroupProps) => {
	const { palette } = useTheme();

	const paddingX = useValuesByScreenSize(44, 24);
	const padding = rem(52, paddingX, 34, paddingX);

	return (
		<ComponentInfo name="LeftPanel">
			<Box
				styles={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: rem(LEFT_PANEL_WIDTH),
					height: '100vh',
				}}
			>
				<Box
					styles={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						height: `calc(100vh)`,
						width: rem(LEFT_PANEL_WIDTH),
						padding,
						background: palette.global.ui18,
						justifyContent: 'space-between',
					}}
				>
					<DisplayGroupRender displayGroupsProps={props} />
				</Box>
			</Box>
			<Box
				styles={{
					display: 'flex',
					width: rem(LEFT_PANEL_WIDTH),
					height: '100vh',
					backgroundColor: 'red',
				}}
			/>
		</ComponentInfo>
	);
};
